import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AdditionalRoutingModule } from './additional-routing.module';
import { AdditionalComponent } from './additional.component';
import { AssetUrlModule } from '@app/@modules/asset-url/asset-url.module';
import { NgbAccordionModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [AdditionalComponent],
  imports: [CommonModule, AdditionalRoutingModule, TranslateModule, AssetUrlModule, NgbNavModule, NgbAccordionModule],
})
export class AdditionalModule {}
